<router-outlet />

@if (loadingService.loading$ | async; as count) {
  @if (count > 0) {
    <div class="loading-overlay">
      <app-ae-icons class="loader" icon="loading"></app-ae-icons>
    </div>
  }
}
